var path = 'src/app/forms/fields/select-field.html';
var html = "<select frm-model frm-required ng-model=data.model ng-options=\"x as x.label for x in data.options track by x.id\" ng-required=required() class=form-control> <option></option> </select> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/forms/fields/select-field.html
 ** module id = 294
 ** module chunks = 0
 **/